import { api } from '@/shared/api/client'
import { qs } from '@/shared/lib/query'

/**
 * Electoral history — how every station actually voted last time.
 *
 * ## Why the platform needed this before it needed anything cleverer
 *
 * Every projection was leaning on canvassing, and canvassing covers a small, self-selected
 * slice of the register. A past result is dated, but it is an actual election: it is the only
 * honest anchor a forecast has before polling day.
 */

export interface HistoricalElection {
  id: string
  code: string
  name: string
  heldOn: string
  electionType: string
  /** Where the numbers came from. Required — a baseline without provenance is an assertion. */
  sourceNote: string
}

export interface UnitGround {
  unitId: string
  unitName: string
  unitPath: string
  registered: number
  cast: number
  turnoutPct: number
  ourVotes: number
  ourSharePct: number
  rivalVotes: number
  marginPp: number
  classification: 'STRONGHOLD' | 'BATTLEGROUND' | 'WEAK' | 'HOSTILE'
  turnoutGapPp: number
  /** Votes a turnout operation could buy here. An upper bound, not a target. */
  turnoutUpside: number
  swingPp: number | null
}

export interface GroundReading {
  historicalElectionId: string
  electionName: string
  seatType: string
  registered: number
  cast: number
  turnoutPct: number
  ourSharePct: number
  strongholds: number
  battlegrounds: number
  weak: number
  hostile: number
  totalTurnoutUpside: number
  units: UnitGround[]
}

export const listHistoricalElections = () =>
  api.get<HistoricalElection[]>('/historical/elections')

export const getGround = (election: string, seatType = 'GOVERNOR', previous?: string) =>
  api.get<GroundReading>(`/historical/ground${qs({ election, seatType, previous })}`)
